<template>
    <ion-page>
        <ion-content :fullscreen="true" class="ion-no-padding">
            <div class="form-section-header">
                <p>{{ language.templateSelection }}</p>
            </div>
            <ion-item lines="full" mode="md" v-for="template of templates" :key="template.id" @click="selectTemplate(template.id)">
                <ion-label>
                    <h2>{{ template.name }}</h2>
                    <p>{{ layoutLabel(template) }}</p>
                    <p>Modified: {{ formatDate(template.lastModified, language) }}</p>
                </ion-label>
                <DirectionIndicator class="edit-forward" :is-ltr-forward="true" />
            </ion-item>
        </ion-content>
    </ion-page>
</template>

<script lang="ts">

import {IonContent, IonItem, IonLabel, IonPage} from '@ionic/vue';
import {execute} from "@/mixins/LoadingMixin";
import {computed, defineComponent, ref} from "vue";
import {JourneyTemplate} from "@/models/JourneyTemplateModel";
import {getCompleteTemplates} from "@/services/TemplateService";
import { formatDate } from '@/utils/DatesUtil';
import {getJourneySet, updateJourneySet} from "@/services/JourneySetService";
import router from "@/router";
import {useStore} from "vuex";
import DirectionIndicator from "@/components/DirectionIndicator.vue";

export default defineComponent({
    name: 'SelectJourneySetTemplate',
    components: {
        DirectionIndicator,
        IonContent,
        IonPage,
        IonItem,
        IonLabel
    },
    props: {
        journeySetId: {
            type: String,
            required: true,
            default: ''
        }
    },
    async ionViewWillEnter() {
        await this.store.dispatch('app/setPageTitle', this.language.journeySetCreation);
        await execute(async () => {
            this.templates = await getCompleteTemplates(this.store.getters['app/selectedAppInstanceId']);
        }, this.language.errors.gettingTemplates);
    },
    setup(props) {
        const store = useStore();
        const language = computed(() => store.getters['app/language']);
        const templates = ref([] as JourneyTemplate[]);

        const selectTemplate = async (templateId: string) => {
            await execute(async () => {
                const editingExisting = props.journeySetId.trim().toLowerCase() !== 'create';
                if (editingExisting) {
                    const journeySet = await getJourneySet(props.journeySetId);
                    journeySet.templateId = templateId;
                    await updateJourneySet(journeySet);
                    await router.push({ name: 'journeySetCategory', params: { journeySetId: props.journeySetId }});
                } else {
                    await router.push({ name: 'journeySetCategory', params: { journeySetId: 'create', templateId: templateId }});
                }
            }, language.value.errors.savingJourneySet);
        }

        const layoutLabel = (template: JourneyTemplate) => {
            return template.enableCustomContent ? language.value.customContentLabel : language.value.basicContentLabel;
        }

        return {
            templates,
            selectTemplate,
            store,
            language,
            formatDate,
            layoutLabel
        }
    }
});
</script>

<style scoped>
</style>